/**
 * Determines whether any of the given mutations occurred on the target element
 * itself or on an ancestor that contains it. This is used to filter
 * MutationObserver callbacks so that only mutations that could affect the
 * target's computed style trigger a re-read.
 *
 * @internal — not part of the public API.
 */
export function isRelevantMutation(mutations: ReadonlyArray<MutationRecord>, target: Element): boolean {
	return mutations.some((mutation) => mutation.target === target || mutation.target.contains(target));
}
